<div class="lista-dados">
  <mat-card class="lista-dados-card" [style.--accent]="corHex">
    <div class="lista-dados-card__header">
      <div class="lista-dados-card__header-left">
        <mat-icon class="lista-dados-card__icon">{{ upIcone }}</mat-icon>
        <span class="lista-dados-card__title">{{ upTitulo }}</span>
      </div>

      <div class="lista-dados-card__header-right" *ngIf="upHabilitaFiltroRapido && !upHabilitaPaginacao">
        <ng-container *ngIf="!filtroRapidoVisivel">
          <button
            mat-icon-button
            type="button"
            class="lista-dados-card__search-button"
            [disabled]="semRegistros || editandoLinhaAtiva"
            (click)="alternarFiltroRapido()">
            <mat-icon>search</mat-icon>
          </button>
        </ng-container>

        <ng-container *ngIf="filtroRapidoVisivel">
          <mat-form-field class="lista-dados-card__search-input" [class.disabled]="semRegistros || editandoLinhaAtiva">
            <input
              #inputFiltroRapido
              matInput
              type="text"
              placeholder="Filtrar"
              [value]="filtroRapido"
              [disabled]="semRegistros || editandoLinhaAtiva"
              (input)="aplicarFiltroRapido($any($event.target).value)">
            <button matSuffix mat-icon-button type="button" (click)="limparFiltroRapido()" [disabled]="semRegistros || editandoLinhaAtiva">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
      </div>
        <span *ngIf="upHabilitaContador" class="lista-dados-card__badge" matTooltip="Quantidade de registros">
          {{ upDados.length }}
      </span>
    </div>

    <div class="lista-dados-card__body-wrapper" [class.lista-dados-card__body-wrapper--vazio]="semRegistros">
      <div class="lista-dados-card__body" [appDisableInteraction]="semRegistros">
        <div class="table-scroll-wrapper" (mouseleave)="pararRolagem()">
        <div #rolagemTabela class="data-table-container" [class.disabled]="semRegistros" (scroll)="atualizarSetasRolagem()">
          <table #tabela mat-table [dataSource]="dataSource" class="data-table mat-elevation-z8">

        <ng-container *ngFor="let coluna of upColunas" [matColumnDef]="coluna.campo">
          <th mat-header-cell *matHeaderCellDef [style.width]="coluna.tamanho" [style.max-width]="coluna.tamanho">
            {{ coluna.rotulo }}
          </th>
          <td mat-cell #cellContent="appDetectTruncation" appDetectTruncation *matCellDef="let row" [style.width]="coluna.tamanho" [style.max-width]="coluna.tamanho" [matTooltip]="obterTextoTooltip(row, coluna)" [matTooltipDisabled]="isLinhaEmEdicao(row) || (!coluna.tooltip && !cellContent.isTruncated())" [matTooltipShowDelay]="300" matTooltipPosition="above" matTooltipClass="lista-dados-tooltip-panel">
            <ng-container *ngIf="isLinhaEmEdicao(row) && podeEditarColuna(coluna)">
              <mat-form-field class="cell-editor" *ngIf="getTipoEditor(coluna) === 'texto'">
                <input
                  matInput
                  type="text"
                  [maxlength]="coluna.edicao?.validacao?.maxLength ?? null"
                  [mask]="coluna.edicao?.validacao?.mask || ''"
                  [(ngModel)]="row[coluna.campo]"
                  (ngModelChange)="onMudouValor(row, coluna, $event)">
              </mat-form-field>

              <mat-form-field class="cell-editor" *ngIf="getTipoEditor(coluna) === 'numero'">
                <input
                  matInput
                  type="number"
                  [min]="coluna.edicao?.validacao?.min ?? null"
                  [max]="coluna.edicao?.validacao?.max ?? null"
                  [(ngModel)]="row[coluna.campo]"
                  (ngModelChange)="onMudouValor(row, coluna, $event)">
              </mat-form-field>

              <mat-form-field class="cell-editor" *ngIf="getTipoEditor(coluna) === 'data'">
                <input
                  matInput
                  [matDatepicker]="picker"
                  [(ngModel)]="row[coluna.campo]"
                  (ngModelChange)="onMudouValor(row, coluna, $event)">
                <mat-datepicker-toggle matSuffix [for]="picker" tabindex="-1"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field class="cell-editor" *ngIf="getTipoEditor(coluna) === 'combobox'">
                <mat-select
                  [(ngModel)]="row[coluna.campo]"
                  (ngModelChange)="onMudouValor(row, coluna, $event)">
                  <mat-option *ngFor="let opcao of obterOpcoesCombo(row, coluna)" [value]="obterValorOpcaoCombo(opcao, coluna)">
                    {{ obterRotuloOpcaoCombo(opcao, coluna) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-checkbox
                *ngIf="getTipoEditor(coluna) === 'checkbox'"
                [(ngModel)]="row[coluna.campo]"
                (ngModelChange)="onMudouValor(row, coluna, $event)">
              </mat-checkbox>

              <input
                *ngIf="getTipoEditor(coluna) === 'cor'"
                class="cell-editor-cor"
                type="color"
                [(ngModel)]="row[coluna.campo]"
                (ngModelChange)="onMudouValor(row, coluna, $event)">
            </ng-container>

              <ng-container *ngIf="!isLinhaEmEdicao(row) || !podeEditarColuna(coluna)">
              <ng-container *ngIf="coluna.tipoExibicao !== 'status'; else statusIcon">
                <ng-container *ngIf="coluna.tipoExibicao === 'cor'; else valorTexto">
                  <span class="lista-dados-cor" [style.background-color]="obterValorExibicao(row, coluna)"></span>
                </ng-container>
                <ng-template #valorTexto>
                  <ng-container *ngIf="coluna.tipoExibicao === 'etiqueta'; else textoValor">
                    <span class="lista-dados-etiqueta" [style.background-color]="obterCorValor(row, coluna)" [style.color]="obterCorTextoValor(row, coluna)">
                      {{ obterValorExibicao(row, coluna) }}
                    </span>
                  </ng-container>
                  <ng-template #textoValor>
                    <span class="lista-dados-valor" [ngClass]="obterClasseValor(row, coluna)">
                      {{ obterValorExibicao(row, coluna) }}
                      <span *ngIf="obterIcone(row, coluna)" class="lista-dados-icone-composto" [ngClass]="obterClasseIcone(row, coluna)">
                        <mat-icon class="lista-dados-icone">{{ obterIcone(row, coluna) }}</mat-icon>
                        <mat-icon *ngIf="obterIconeSecundario(row, coluna)" class="lista-dados-icone lista-dados-icone--secundario">
                          {{ obterIconeSecundario(row, coluna) }}
                        </mat-icon>
                      </span>
                    </span>
                  </ng-template>
                </ng-template>
              </ng-container>
              <ng-template #statusIcon>
                <mat-icon [class.lista-dados-status--ativo]="isStatusAtivo(row, coluna)" [class.lista-dados-status--revogado]="!isStatusAtivo(row, coluna)">
                  {{ isStatusAtivo(row, coluna) ? 'check_circle' : 'cancel' }}
                </mat-icon>
              </ng-template>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="acoes" *ngIf="exibeColunaAcoes">
          <th mat-header-cell *matHeaderCellDef class="acoes-coluna" [class.acoes-coluna--edicao]="editandoLinhaAtiva">
            <button
              *ngIf="upHabilitaBotaoIncluir"
              id="lista-dados-botao-adicionar"
              mat-mini-fab
              class="accent-fab-button ignore-disable"
              [disabled]="editandoLinhaAtiva"
              (click)="onAcaoIncluir()">
              <mat-icon>add</mat-icon>
            </button>
          </th>
          <td class="acoes-coluna" [class.acoes-coluna--edicao]="editandoLinhaAtiva" mat-cell *matCellDef="let row">
            <mat-menu #menuLinha="matMenu">
              <button mat-menu-item *ngIf="upHabilitaBotaoEditar && isBotaoEditarVisivel(linhaSelecionada)" (click)="onCliqueEditar()">
                <mat-icon>{{ upIconeBotaoEditar }}</mat-icon>
                <span>{{ upTextoBotaoEditar }}</span>
              </button>
              <ng-container *ngFor="let acao of upAcoesLinha">
                <button
                  mat-menu-item
                  *ngIf="isAcaoLinhaVisivel(acao, linhaSelecionada)"
                  [disabled]="isAcaoLinhaDesabilitada(acao, linhaSelecionada)"
                  (click)="onCliqueAcaoLinha(acao)">
                  <mat-icon>{{ acao.icone }}</mat-icon>
                  <span>{{ acao.texto }}</span>
                </button>
              </ng-container>
              <button mat-menu-item *ngIf="upHabilitaBotaoExcluir && isBotaoExcluirVisivel(linhaSelecionada)" (click)="onCliqueExcluir()">
                <mat-icon>{{ upIconeBotaoExcluir }}</mat-icon>
                <span>{{ upTextoBotaoExcluir }}</span>
              </button>
            </mat-menu>

            <button
              *ngIf="isLinhaEmEdicao(row)"
              mat-mini-fab
              class="cell-button"
              color="primary"
              matTooltip="Salvar"
              [disabled]="!podeSalvarLinha(row)"
              (click)="onSalvarLinha(row)">
              <mat-icon>save</mat-icon>
            </button>

            <button
              *ngIf="isLinhaEmEdicao(row)"
              mat-mini-fab
              class="cell-button"
              color="warn"
              matTooltip="Cancelar"
              (click)="onCancelarLinha(row)">
              <mat-icon>cancel</mat-icon>
            </button>

            <button
              mat-icon-button
              class="cell-button"
              [matMenuTriggerFor]="menuLinha"
              [disabled]="!temAcaoLinhaDisponivel(row)"
              [matTooltip]="temAcaoLinhaDisponivel(row) ? 'Ações' : 'Lembrete disponível somente para consulta'"
              (click)="abrirMenuLinha(row)"
              *ngIf="exibeMenuLinha(row)">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

          <tr mat-header-row *matHeaderRowDef="colunasExibidas"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: colunasExibidas;"
            [class.lista-dados-card__row--em-edicao]="isLinhaEmEdicao(row)"
            [ngClass]="upClasseLinha(row)">
          </tr>
          </table>
        </div>
        <button *ngIf="podeRolarParaEsquerda && !semRegistros" type="button"
          class="table-scroll-arrow table-scroll-arrow--left" aria-label="Rolar tabela para a esquerda"
          (mouseenter)="iniciarRolagem(-1)" (mouseleave)="pararRolagem()" (blur)="pararRolagem()" (click)="rolarTabela(-1)">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button *ngIf="podeRolarParaDireita && !semRegistros" type="button"
          class="table-scroll-arrow table-scroll-arrow--right" aria-label="Rolar tabela para a direita"
          (mouseenter)="iniciarRolagem(1)" (mouseleave)="pararRolagem()" (blur)="pararRolagem()" (click)="rolarTabela(1)">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        </div>

        <mat-paginator
          showFirstLastButtons
          [length]="totalRegistrosPaginacao"
          [pageIndex]="upPaginaAtual"
          [pageSize]="upItensPorPagina"
          [pageSizeOptions]="upOpcoesItensPorPagina"
          (page)="onMudouPagina($event)">
        </mat-paginator>
      </div>

      <div class="lista-dados-overlay" *ngIf="semRegistros && !upCarregando">
        <mat-card class="nenhum-registro">
          <p class="mensagem">Nenhum registro encontrado</p>

          <div class="registro-actions" *ngIf="upHabilitaBotaoIncluir">
            <div class="action-item">
              <button mat-fab class="accent-fab-button" (click)="onAcaoIncluir()" [disabled]="editandoLinhaAtiva">
                <mat-icon>add</mat-icon>
              </button>
              <span>Novo Registro</span>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
  </mat-card>

  <div class="subscription" *ngIf="upCarregando">
    <div>
      <mat-spinner></mat-spinner>
      <p>Carregando...</p>
    </div>
  </div>
</div>
